import React from 'react';
import { FormattedMessage } from 'react-intl';
import eraserSolid from "../../assets/icons/signage-plus/eraser-solid.svg";
import SwitchComponent from './SwitchComponent';

function PlaylistHeaderActions({
  selectedPlaylistId,
  // tabData,
  // playlistLoopSwitch,
  // loop,
  setPlaylistOrderMap,
  handleToggleLoop,
  // playlistItems,
  playlistHeader
}) {
  return (
    <div className="d-flex align-items-center playlist-header-actions ms-3">
      <div className={`badge rounded-pill keepMultiSpaces text-bg-darkgrey ${selectedPlaylistId ? '' : 'no-playlist-selected'}`} >
        {selectedPlaylistId ? playlistHeader.name : <FormattedMessage id="NO_PLAYLIST_SELECTED" defaultMessage="No Playlist Selected" />}
      </div>
      {/* <div className="form-check form-switch">
        <SwitchComponent check={playlistHeader.isLoop} id={playlistHeader.id} labelId="LOOP_PLAYLIST" className='red' onChange={(checked, id) => {  handleToggleLoop(checked, id) }}  />
      </div>
      <button
        type="button"
        className="d-flex align-items-center justify-content-center playlist-clear-btn"
        onClick={() => {
          setPlaylistOrderMap(map => {
            const newMap = { ...map };
            newMap[selectedPlaylistId] = [];
            return newMap;
          });
        }}
      >
        <img src={eraserSolid} alt="clear" className="playlist-clear-icon" />
        <span className='label-regular'>
          <FormattedMessage id="CLEAR_ALL" defaultMessage="clear all" />
        </span>
      </button> */}
    </div>
  );
}

export default PlaylistHeaderActions;
